import React, {FC} from 'react';
import SentimentSlider from './sentiment_slider';
import StuckItems from './stuck_items';
import {TaskField, TaskFieldRequiredState} from '../../../../../../constants/tasks';
import {EmployeeSatisfactionStatuses, EmployeeStuckItem, TaskFormField} from '../../../../types';

const questionTypeToFormField = {
  [TaskField.SENTIMENT_SLIDER]: SentimentSlider,
  [TaskField.EMPLOYEE_STUCKS_CHECKLIST]: StuckItems
};

type QuestionProps = {
  field: TaskFormField,
  stuckItems: Nullable<EmployeeStuckItem[]>,
  satisfactionStatuses: Nullable<EmployeeSatisfactionStatuses[]>,
  disabled: boolean
};

const Question: FC<QuestionProps> = ({
  field,
  stuckItems,
  satisfactionStatuses,
  disabled}) => {
  const {type, name, id, required} = field || {};

  const Component = questionTypeToFormField[type];

  if (!Component) {
    return null;
  }

  return (
    <Component
      name={`${id}`}
      required={required === TaskFieldRequiredState.REQUIRED}
      label={name}
      disabled={disabled}
      stuckItems={stuckItems}
      satisfactionStatuses={satisfactionStatuses}
    />
  );
};

export default Question;
